

import React from 'react';
import BrandedButton, { brandedButtonTypes } from '../../../utilities/inputComponents/BrandedButton';


function StartSession({handleStartSession,clickToDial}) {


    return (
        <div className="warningWrapper">
            <div className="warningBody" style={{height:'35%'}}>
                <div className="warningHeader">
                    Session Ready
                </div>
                <div className="warningContent">
                    Are you ready to start your session?
                </div>
                <div className="warningButtonHolder" style={{margin: '0px 0px', position: 'unset'}}>
                    <div className="warningButtonWrapper">
                        <div key={'sess1'} style={{ maxWidth: '400px', margin: '10px auto 0px' }}>
                            <BrandedButton
                                buttonType={brandedButtonTypes.PRIMARY}
                                buttonLabel='Start Auto Dial Session'
                                clickHandler={_ => handleStartSession()}
                            />
                        </div>
                        <div key={'sess2'} style={{ maxWidth: '400px', margin: '10px auto 0px' }}>
                            <BrandedButton
                                buttonType={brandedButtonTypes.PRIMARY}
                                buttonLabel='Click To Dial'
                                clickHandler={_ => clickToDial()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StartSession;